import { useGameStore } from '../../store/gameStore';

const LAYER_LABELS = ['LAYER 0', 'LAYER 1', 'LAYER 2', 'LAYER 3'];
const LAYER_NAMES = ['Outer World', 'Snake', 'Breakout', 'Reaction'];
const DEPTH_COLORS = ['bg-blue-600', 'bg-green-600', 'bg-orange-500', 'bg-purple-600'];

export function HUD() {
  const phase = useGameStore((s) => s.phase);
  const currentDepth = useGameStore((s) => s.currentDepth);
  const totalScore = useGameStore((s) => s.totalScore);
  const highScore = useGameStore((s) => s.highScore);
  const scoreMultiplier = useGameStore((s) => s.scoreMultiplier);

  if (phase === 'idle' || phase === 'game-over') return null;

  return (
    <div className="border-b border-gray-800">
      <div className="flex items-center justify-between px-4 py-2 bg-gray-900">
        <div className="flex items-center gap-3">
          <span
            className={`px-2 py-0.5 rounded text-xs font-bold text-white ${DEPTH_COLORS[currentDepth] ?? 'bg-gray-600'}`}
          >
            {LAYER_LABELS[currentDepth] ?? 'LAYER ?'}
          </span>
          <span className="text-gray-300 text-sm font-medium">
            {LAYER_NAMES[currentDepth] ?? 'Unknown'}
          </span>
          {scoreMultiplier > 1 && (
            <span className="px-2 py-0.5 rounded text-xs font-bold text-black bg-yellow-400 animate-pulse">
              {scoreMultiplier}x COMBO
            </span>
          )}
        </div>
        <div className="flex items-center gap-6 font-mono text-sm">
          <span className="text-yellow-400">
            SCORE <span className="text-white font-bold">{totalScore}</span>
          </span>
          <span className="text-gray-500">
            BEST <span className="text-gray-300">{highScore}</span>
          </span>
        </div>
      </div>
      <div className="flex items-center justify-center gap-4 px-4 py-1 bg-gray-950 text-xs text-gray-600">
        <span>↑↓←→ / WASD &nbsp;Move</span>
        <span>|</span>
        <span>Enter / Space &nbsp;Interact</span>
        <span>|</span>
        <span>Escape &nbsp;Ascend</span>
      </div>
    </div>
  );
}
